module.exports = new __parcel__URL__("shop_resource_packs_button_inactive.27c3ecec.png").toString();